module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/playms2-8bf04148f4cb9d7ee3e3f5a9b7849582.png";